<template>
  <button
    :class="['button button-' + variant]"
    @click="onClick"
    :style="styling"
    :id="id"
  >
    <!-- @slot Use this slot for button name
    @default 'test'
    @binding {object} icon icon of the menu item
		@binding {string} text text of the menu item -->

    <slot>Button</slot>
  </button>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'RexButton',
  props: {
    /**
     *
     *Type of button to be rendered
     *
     */
    variant: { type: String, required: true, default: 'primary' },
    /**
     *
     *id for qa
     *
     */
    id: { type: String, required: true },
    /**
     * Additional styling to be added to the button
     */

    styling: {
      type: Object,
      default: function () {
        return {
          width: '89px',
        };
      },
    },
  },
  emits: ['onClick'],
  methods: {
    /**
     *  Triggers when button is clicked.
     *
     * @method onClick
     *
     */
    onClick() {
      /**
       *  emits onClick event when button is clicked.
       *
       * @event onClick
       *@property {object}
       */

      this.$emit('onClick');
    },
  },
};
</script>
<style lang="scss">
.button {
  border: none;
  border-radius: 0.313rem;
  text-align: center;
  font-size: 1.125rem;
  height: 2.5rem;
  width: 5.563em;
  // margin: 0.25rem 0.125rem;
  cursor: pointer;
  line-height: 1.375rem;
  @include dropshadow-effect;
}
.button-primary {
  background-color: $color-brand-accent;
  color: $font-contrast;
  border: none;
}
.button-secondary {
  background-color: transparent;
  border: 0.0625rem solid $color-brand-accent;
  color: $color-brand-accent;
}
.button-tertiary {
  background-color: transparent;
  border: 0.0625rem solid $color-brand-accent;
  color: $color-brand-accent;
}
.button-quaternary {
  background-color: $font-secondary;
  color: $font-contrast;
}
.button-transparent {
  background-color: inherit;
  color: white;
  border: 0.0625rem solid white;
}

.button-disabled {
  pointer-events: none;
  cursor: not-allowed !important;
  background-color: $button-disabled-light;
  color: $button-disabled-text;
}
</style>
